(() => {
  const init = () => {
    const badge = document.querySelector('[data-google-review-widget]');
    if (!badge || badge.dataset.ready) return;
    badge.dataset.ready = 'true';
    const key = 'fgm-google-reviews-dismissed';
    try { if (sessionStorage.getItem(key) === '1') badge.hidden = true; } catch (_) {}
    badge.querySelector('.fgm-google-reviews__close').addEventListener('click', () => {
      badge.hidden = true;
      try { sessionStorage.setItem(key, '1'); } catch (_) {}
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
